import { render, staticRenderFns } from "./BasePdfReader.vue?vue&type=template&id=3d8fbb31"
import script from "./BasePdfReader.vue?vue&type=script&lang=js"
export * from "./BasePdfReader.vue?vue&type=script&lang=js"
import style0 from "./BasePdfReader.vue?vue&type=style&index=0&id=3d8fbb31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports